module.exports = __webpack_public_path__ + "media/21.e754e76d.wav";